import React, { useEffect, useRef, useState } from "react";
import { api } from "../actions/api";
import ShareDocumentModal from "../Components/ShareDocumentModal";
import html2pdf from "html2pdf.js";
import BaseModal from "./Modals/BaseModal";
import JournalShareModal from "./JournalShareModal";

// Utility function to format dates
const formatDateWithOrdinal = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "long" });
  const year = date.getFullYear();

  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return `${month} ${getOrdinal(day)},${year}`;
};

const ViewAllMemoryModal = ({
  open,
  currentMemoryJournalId,
  memoryloading,
  handleRefresh,
  onClose,
  openSummaryModal,
}) => {
  const [journalDetails, setJournalDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const modalRef1 = useRef(null);
  const [isFullMemoryModalOpen, setIsFullMemoryModalOpen] = useState(false);
  const [titleToShare, setTitleToShare] = useState("Share Your Full Memory");
  const [showJournalShareModal, setShowJournalShareModal] = useState(false);

  useEffect(() => {
    const fetchJournalDetails = async () => {
      if (!currentMemoryJournalId) {
        setJournalDetails(null);
        return;
      }
      setLoading(true);
      try {
        const response = await api.get(
          `/user-journals/${currentMemoryJournalId}/details`,
        );
        setJournalDetails(response.data.data.user_journal);
      } catch (err) {
        console.error("Error fetching journal details:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchJournalDetails();
  }, [currentMemoryJournalId, handleRefresh]);

  const handleGenerateAndShare = async () => {
    setTitleToShare(journalDetails?.journal?.emotion_name);
    setShowJournalShareModal(true);
  };

  const handleCloseModal = () => {
    setShowJournalShareModal(false);
    setTitleToShare("Share you Journal");
    onClose();
  };

  if (!open) return null;

  return (
    <>
      {!isFullMemoryModalOpen && (
        <BaseModal open={open} onClose={onClose} title="My Memory" width={680}>
          <div className="memory-modal-subtitle d-flex justify-content-between">
            <div className="meta-info gap-2 d-flex">
              <img src="/icons/discover.svg" alt="Emotion Icon" />
              <span>{journalDetails?.journal?.emotion_name} Stack</span>
            </div>
            <div className="meta-info gap-2 d-flex">
              <span>{formatDateWithOrdinal(journalDetails?.updated_at)}</span>
              <img
                src="/icons/rotate-right.svg"
                alt="Refresh"
                onClick={handleRefresh}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          <div
            className="memory-modal-body"
            ref={modalRef1}
            style={{
              marginTop: 16,
              maxHeight: "60vh", // or any suitable height
              overflowY: "auto",
              paddingRight: "8px",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {loading ? (
              <div className="text-center py-5">
                <div className="loader-container">
                  <div className="loader" />
                </div>
              </div>
            ) : (
              <div className="all-modal-content">
                <div className="story-section">
                  <h6 className="section-title">
                    Full Stack Memory: {journalDetails?.journal?.emotion_name}{" "}
                    Journal
                  </h6>
                  {journalDetails?.journal_answers
                    ?.filter(
                      (answer) => answer.user_journal_id === journalDetails?.id,
                    )
                    .map((answer, index) => (
                      <div key={index} className="mt-4">
                        <p
                          className="questions-title text-white"
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "pre-wrap",
                            overflow: "hidden",
                          }}
                        >
                          {answer.main_question?.question ||
                            answer.follow_up_question?.question}
                        </p>
                        {answer.text && (
                          <p
                            className="ans-title"
                            style={{
                              wordWrap: "break-word",
                              whiteSpace: "pre-wrap",
                              overflow: "hidden",
                              color: "white",
                            }}
                            dangerouslySetInnerHTML={{ __html: answer.text }}
                          />
                        )}
                      </div>
                    ))}
                </div>
              </div>
            )}
            <div className="d-flex flex-column justify-content-between align-items-center gap-3 mt-3">
              <button
                className="full-mem-btn btn-3 btn-1-basic"
                style={{ maxWidth: "205px", width: "100%" }}
                onClick={openSummaryModal}
              >
                <span className="text-body-b3" style={{ whiteSpace: "nowrap" }}>
                  Back To My Memory
                </span>
              </button>
              <button
                className="btn-2 btn-1-primary"
                style={{ maxWidth: "205px", width: "100%" }}
                onClick={handleGenerateAndShare}
              >
                Share
              </button>
            </div>
          </div>
        </BaseModal>
      )}

      {showJournalShareModal && (
        <JournalShareModal
          show={showJournalShareModal}
          title={titleToShare}
          onClose={handleCloseModal}
          journalId={currentMemoryJournalId}
        />
      )}
    </>
  );
};

export default ViewAllMemoryModal;
